import React, { useCallback } from 'react'
import Scroll from '@yk-component/yk-scroll'
import Loading from 'meinian-package/src/baseComponent/loading'
import { Empty } from 'meinian-package/src/baseComponent'
import BaseMasonry from 'component/waterfall/baseMasonry'
import { RULES } from 'component/waterfall/masonryApi'

export type TMasonry={
  data: any,
  isEnd: boolean,
  loading : boolean,
  cardProps ?: any,
  loadingText ?: string,
  root?:any,
  columnCount?:number,
  rule?:any,
  gutter?:number,
  cardKey?:any,
  renderItem?:any,
  endText?:string,
  empty?:React.ReactNode | string,
  emptyType?:any,
  emptyText?:any,
  onEnd?:any,
  $masonry?:any,
}

export default ({
  data,
  isEnd,
  loading,
  cardProps,
  loadingText,
  root,
  columnCount,
  rule = RULES.M,
  gutter = 20,
  cardKey,
  renderItem,
  endText,
  empty,
  emptyType,
  emptyText,
  onEnd,
  $masonry,
}:TMasonry) => {
  const getAutoColumnCount = useCallback((width) => {
    for (let i = 0; i < rule.widths.length; i++) {
      if (width >= rule.widths[i]) return rule.maxColumnCount - i
    }
  }, [rule])

  function render() {
    if (data?.length) {
      return <>
        <Scroll
          onEnd={onEnd}
          isEnd={isEnd}
          loading={loading}
          root={() => root || document.body}
          marginBottom={200}
        >
          <BaseMasonry
            instance={$masonry}
            data={data}
            itemKey={(item, index) => (cardKey ? cardKey(item, index) : item.uuidKey)}
            gutter={gutter}
            zIndex={i => -i}
            renderItem={(item, width) => renderItem?.({
              ...item,
              itemData: item,
              columnWidth: width,
              ...cardProps,
            })}
            columnCount={(_width) => columnCount || getAutoColumnCount(_width)}
          />
        </Scroll>
        {!isEnd && loading ? <div style={{ textAlign: 'center', color: 'var(--m-text-3)', padding: 32 }}>{loadingText || '加载中~'}</div> : null}
        {isEnd && !loading && <div style={{ textAlign: 'center', color: 'var(--m-text-3)', padding: 32 }}>{endText || '没有更多啦~'}</div>}
      </>
    }
    if (loading) {
      return <Loading loading={loading} wrapperClassName="spin-transparent-bg"><div style={{ height: 400 }} /></Loading>
    }
    return empty || <Empty type={emptyType} title={emptyText} />
  }

  return <div style={{ margin: 'auto' }}>
    {render()}
  </div>
}
